import axios from "axios";

export default {
  async findAll() {
    return axios.get(`/booking-status`);
  },
  async updateColorsAndVisibility(formData) {
    return axios.put(`/booking-status/colors`, {bookingStatus: formData});
  }
};
